'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'user-bounty-hunter';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2bf';
var svgPathData = ['M8 512c4.5 0 8-3.6 8-8 0-75.1 60.9-136 136-136l144 0c75.1 0 136 60.9 136 136 0 4.4 3.6 8 8 8l-128 0c2.1 0 4.1-.8 5.7-2.3 3.1-3.1 3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3 1.6 1.6 3.6 2.3 5.6 2.3L8 512zM81.7 257.2L86 180c51.8 13.9 90.7 59.4 94.6 114.7l-80-16.8c-10.2-2.2-17.7-10.6-18.9-20.6zM89.9 128c7.3-40.8 32.7-75.1 67.4-94.6 19.8-11.1 42.5-17.4 66.7-17.4 66.6 0 122.6 48 134.1 112L89.9 128zM267.4 294.7c3.9-55.2 42.8-100.8 94.6-114.7l4.3 77.2c-1.2 10-8.7 18.5-18.9 20.6l-80 16.8z', 'M64 8c0-4.4 3.6-8 8-8L96 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-16 0 0 86.6C100.6 42.6 157.7 0 224 0 252.1 0 278.5 7.6 301.2 21 343.5 45.9 372.9 90.8 376 143.1L382.4 252c.1 1.9 .1 3.7-.1 5.6l.2 3c.9 15.8-9.9 29.8-25.4 33.1L239.8 318.4c-4.9 1-9.9 1.6-15 1.6l-.9 .2-.9-.2c-5-.1-10-.6-15-1.6L90.9 293.7c-13.9-2.9-24-14.6-25.3-28.4-1-3.6-1.6-7.4-1.6-11.2L64 8zm36.6 269.8l80 16.8C176.7 239.5 137.8 193.9 86 180l-4.3 77.2c1.2 10 8.7 18.4 18.9 20.6l0 0zM88 144.7l-1.1 19.1c61.3 14.9 107.3 69 109.9 134.4l19.2 4 0-158.1-128 0 0 .7zm179.4 150l80-16.8c10.2-2.1 17.7-10.6 18.9-20.6L362 180c-51.8 13.9-90.7 59.4-94.6 114.7zm-16.2 3.4c2.6-65.3 48.6-119.4 109.9-134.4l-1.1-19.1 0-.7-128 0 0 158.1 19.2-4zM358.1 128c-11.5-64-67.4-112-134.1-112-24.2 0-46.9 6.3-66.7 17.4-34.7 19.5-60 53.8-67.4 94.6l268.1 0zM16 504c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-83.9 68.1-152 152-152l144 0c83.9 0 152 68.1 152 152 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-75.1-60.9-136-136-136l-144 0C76.9 368 16 428.9 16 504zm213.7-93.7l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-82.3-82.3-82.3 82.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l88-88c3.1-3.1 8.2-3.1 11.3 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserBountyHunter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;